import React from "react";
import { siteImages } from "../data/redlandGolfContent";
import { useSiteContent } from "../context/ContentContext";
import { ContactForm } from "../components/ContactForm";
import { ButtonLink } from "../components/ButtonLink";
import {
  Breadcrumbs,
  Card,
  ContactInfoCard,
  PageHero,
  SectionHeading,
} from "../components/RedlandComponents";

export default function ContactUs() {
  const { contact } = useSiteContent();
  return (
    <>
      <Breadcrumbs current="Contact Us" />
      <PageHero
        eyebrow="Visit Redland Golf"
        title="Contact Redland Golf"
        copy="Call, email, or get directions to Redland Golf & Country Club in Homestead, Florida."
        image={siteImages.palmCourse}
        badge="Homestead, Florida"
        tags={["Tee Times", "Membership", "Junior Golf", "The Sand Trap"]}
        metaTitle="Find Us"
        metaItems={[contact.addressLine1, contact.cityStateZip, contact.phoneDisplay]}
        variant="split"
        actions={<ButtonLink href={contact.phoneHref}>Call Us</ButtonLink>}
      />
      <section className="section">
        <div className="container card-grid three">
          <ContactInfoCard title="Call Us">
            <a href={contact.phoneHref}>{contact.phoneDisplay}</a>
          </ContactInfoCard>
          <ContactInfoCard title="Email Us">
            <a href={contact.emailHref}>{contact.email}</a>
          </ContactInfoCard>
          <ContactInfoCard title="Find Us">
            <a href={contact.directionsHref}>
              {contact.addressLine1}
              <br />
              {contact.cityStateZip}
            </a>
          </ContactInfoCard>
        </div>
      </section>
      <section className="section section-cream">
        <div className="container card-grid two">
          <Card>
            <h2>Department Extensions</h2>
            <ul className="clean-list">
              <li>Tee Times and Pro Shop: Extension 1</li>
              <li>Junior Camp, Tim Tronzo: Extension 3</li>
              <li>The Sand Trap: Extension 4</li>
            </ul>
          </Card>
          <Card>
            <h2>Rating</h2>
            <p>{contact.googleRating}</p>
          </Card>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <SectionHeading title="Map" copy={contact.fullAddress} />
          <div className="map-frame">
            <iframe
              src={contact.mapEmbedSrc}
              title="Map to Redland Golf & Country Club"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="section-action">
            <ButtonLink href={contact.directionsHref} variant="secondary">
              Get Directions
            </ButtonLink>
          </div>
        </div>
      </section>
      <section className="section section-cream">
        <div className="container narrow">
          <SectionHeading
            title="Send a Message"
            copy="No backend submission endpoint exists yet, so this form opens your email app with the message prepared."
          />
          <ContactForm />
        </div>
      </section>
    </>
  );
}
